<template>
  <SfAccordionItem :id="id" v-model="open" data-testid="id" class="w-full">
    <template #summary>
      <div class="mb-2 flex justify-between p-2">
        <UiHeading type="h5">{{ title }}</UiHeading>
        <IconChevron :class="[`size-6 fill-neutral-500`, { 'rotate-180': open }]" />
      </div>
    </template>
    <slot />
  </SfAccordionItem>
</template>

<script setup lang="ts">
import type { AccordionItemProps } from '~/components/ui/AccordionItem/types';

const props = defineProps<AccordionItemProps>();

const open = ref<boolean>(props.openedByDefault);
</script>
